/**
 *  外呼机器人相关接口
 */

import { requestApiV2 } from '@library'
import {
  RobotItem, RobotTaskItem, Pagination, CommonList, CreateRobotCallRollParams, ListCallRollTitleFilter, ListCallRollTitleItem,
  ListRobotCallRollFilter, ListRobotCallRollItem, ListCallTagFilter, ListRobotCallRecordFilter, RobotCallRecordItem, ActivityListWithMarketingWordsRecordItem,
  T3CAgentItem,
  ListT3CRobotCallRecordFilter,
  T3CRobotCallRecordItem,
  T3CCallNumbersItem,
  RobotCallRollOperateParams,
} from '@types'

// 机器人列表 https://opc-mock.woa.com/project/562/interface/api/5965
export function getListRobot (params: Pagination) {
  return requestApiV2<CommonList<RobotItem>>('trpc.tcc.tcc_main.Robot/ListRobot', params)
}

// 创建机器人名单 https://opc-mock.woa.com/project/562/interface/api/5938
export function createRobotCallRoll (params: CreateRobotCallRollParams) {
  return requestApiV2<{rollId: number}>('trpc.tcc.tcc_main.Robot/CreateRobotCallRoll', params)
}

// 机器人名单名称列表 https://opc-mock.woa.com/project/562/interface/api/5956
export function listCallRollTitle (params: ListCallRollTitleFilter) {
  return requestApiV2<ListCallRollTitleItem[]>('trpc.tcc.tcc_main.Robot/ListCallRollTitle', params)
}

// 机器人名单 https://opc-mock.woa.com/project/562/interface/api/5983
export function listRobotCallRoll (params: ListRobotCallRollFilter) {
  return requestApiV2<ListRobotCallRollItem[]>('trpc.tcc.tcc_main.Robot/ListRobotCallRoll', params)
}

// 暂停机器人名单（仅 T3C 进行中任务可调用）
export function pauseRobotCallRoll (params: RobotCallRollOperateParams) {
  return requestApiV2('trpc.tcc.tcc_main.Robot/PauseRobotCallRoll', params)
}

// 恢复机器人名单（仅已暂停的 T3C 任务可调用）
export function resumeRobotCallRoll (params: RobotCallRollOperateParams) {
  return requestApiV2('trpc.tcc.tcc_main.Robot/ResumeRobotCallRoll', params)
}

// 删除机器人名单（任意状态可调用）
export function deleteRobotCallRoll (params: RobotCallRollOperateParams) {
  return requestApiV2('trpc.tcc.tcc_main.Robot/DeleteRobotCallRoll', params)
}

// 机器人任务列表 http://opc-mock.woa.com/project/562/interface/api/6315
export function getListRobotTask (params: Pagination) {
  return requestApiV2<CommonList<RobotTaskItem>>('trpc.tcc.tcc_main.Robot/ListRobotTask', params)
}

// 机器人外呼通话标签列表 https://opc-mock.woa.com/project/562/interface/api/5947
export function listCallTag (params: ListCallTagFilter) {
  return requestApiV2<string[]>('trpc.tcc.tcc_main.Robot/ListCallTag', params)
}

// 机器人外呼通话记录列表 https://opc-mock.woa.com/project/562/interface/api/5974
export function listRobotCallRecord (params: ListRobotCallRecordFilter) {
  return requestApiV2<CommonList<RobotCallRecordItem>>('trpc.tcc.tcc_main.Robot/ListRobotCallRecord', params)
}

// 下载机器人外呼记录 http://opc-mock.woa.com/project/562/interface/api/6127
export function exportRobotCallRecordList (params: ListRobotCallRecordFilter) {
  return requestApiV2<CommonList<RobotCallRecordItem>>('trpc.tcc.tcc_main.Robot/ExportRobotCallRecordList', params)
}

// 热门活动列表 https://iwiki.woa.com/p/4012715988
export function getActivityListWithMarketingWords (params: { page:number, pageSize:number, dataRange?:number, productName?:Array<string>, inWhiteList?:boolean }) {
  return requestApiV2<CommonList<ActivityListWithMarketingWordsRecordItem>>('trpc.tcc.tcc_main.AIBot/GetActivityListWithMarketingWords', params)
}

// 查询点石产品 https://iwiki.woa.com/p/4013055820
export function queryProductList (params) {
  return requestApiV2('trpc.tcc.tcc_main.AIBot/GetProductByProductName', params)
}

// 获取T3C机器人外呼通话记录列表
export function listT3CRobotCallRecord (payload: ListT3CRobotCallRecordFilter) {
  return requestApiV2<CommonList<T3CRobotCallRecordItem>>('trpc.tcc.tcc_main.Robot/ListT3CRobotCallRecord', payload)
}

// t3c智能体列表
export function getT3CAgentList (params: Pagination) {
  return requestApiV2<CommonList<T3CAgentItem>>('trpc.tcc.tcc_main.Robot/ListT3CAgent', params)
}

// 获取T3C号码列表
export function getT3CCallNumbers (payload?: { page?: number, pageSize?: number, isAIOutbound?: boolean }) {
  return requestApiV2<T3CCallNumbersItem>('trpc.tcc.tcc_main.Call/GetT3CCallNumbers', payload)
}


// 下载T3C机器人外呼记录
export function exportT3CRobotCallRecordList (params: ListT3CRobotCallRecordFilter) {
  return requestApiV2<CommonList<RobotCallRecordItem>>('trpc.tcc.tcc_main.Robot/ExportT3CRobotCallRecordList', params)
}
